'use strict'
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);

const BurgerMenuButton = document.querySelector(".burger_menu_button");
const BurgerMenu = document.querySelector(".burger_menu");
const CloseBurgerMenuButton = document.querySelector(".close_burger_menu");

BurgerMenuButton.addEventListener("click", () => {
    BurgerMenu.classList.add("display");
    document.querySelector("body").classList.add("blocked");
})
CloseBurgerMenuButton.addEventListener("click", () => {
    BurgerMenu.classList.remove("display");
    document.querySelector("body").classList.remove("blocked");
})

if (document.querySelector("body").classList.contains("main") == true) {
    let GridButton = document.querySelector(".show_grid");
    let Grid = document.querySelector(".grid_container")
    let Background = document.querySelector(".background__container");
    let FirstLink = document.getElementById("firstlink")
    let SecondLink = document.getElementById("secondlink")
    let ThirdLink = document.getElementById("thirdlink")
    let FourthLink = document.getElementById("fourthlink")
    let Image = document.createElement("img")
    var Images = [
        "assets/images/first_link_background.png",
        "assets/images/second_link_background.png",
        "assets/images/third_link_background.png",
        "assets/images/fourth_link_background.png"
    ]
    let FirstSection = document.querySelector(".first_section")
    let SecondSection = document.querySelector(".second_section")
    let ThirdSection = document.querySelector(".third_section")
    let FourthSection = document.querySelector(".fourth_section")
    let Up = document.querySelector(".up")

    GridButton.addEventListener("click", () => {
        Grid.classList.toggle("hidden");
        GridButton.classList.toggle("stick")
        if (Grid.classList.contains("hidden") == true) {
            GridButton.innerHTML = "Dévoiler la grille"
        } else {
            GridButton.innerHTML = "Masquer la grille"
        }
    })

    FirstLink.addEventListener("click", () => {
        gsap.to(window, {duration: 0.5, scrollTo: ((FirstSection.offsetTop) - 50)})
    })

    SecondLink.addEventListener("click", () => {
        gsap.to(window, {duration: 0.5, scrollTo: ((SecondSection.offsetTop) - 50)})
    })
    ThirdLink.addEventListener("click", () => {
        gsap.to(window, {duration: 0.5, scrollTo: ((ThirdSection.offsetTop) - 50)})
    })
    FourthLink.addEventListener("click", () => {
        gsap.to(window, {duration: 0.5, scrollTo: ((FourthSection.offsetTop) - 50)})
    })

    window.addEventListener("scroll", () => {
        if (window.scrollY >= (FirstSection.offsetTop-50)) {
            Up.classList.add("afficher")
        } else {
            Up.classList.remove("afficher")
        }
    })

    Up.addEventListener("click", () => {
        gsap.to(window, {duration:0.5, scrollTo:0})
    })

    FirstLink.addEventListener("mouseover", () => {
        coverscreen(Images[0])}
    );
    SecondLink.addEventListener("mouseover", () => {
        coverscreen(Images[1])}
    );
    ThirdLink.addEventListener("mouseover", () => {
        coverscreen(Images[2])}
    );
    FourthLink.addEventListener("mouseover", () => {
        coverscreen(Images[3])}
    )

    FirstLink.addEventListener("mouseleave", () => {
        removeimage()
    })
    SecondLink.addEventListener("mouseleave", () => {
        removeimage()
    })
    ThirdLink.addEventListener("mouseleave", () => {
        removeimage()
    })
    FourthLink.addEventListener("mouseleave", () => {
        removeimage()
    })

    function removeimage() {
        Background.removeChild(Image)
    }

    function coverscreen(picture) {
        Image.setAttribute("src", picture)
        console.log("yo")
        Background.appendChild(Image)
    }
}

if (document.querySelector("body").classList.contains("presentation_page") == true) {
    const Descriptions = document.querySelectorAll(".description")
    const Close = document.querySelectorAll(".close");
    let Team = [
                    ".mathis",
                    ".dorian",
                    ".pina",
                    ".nathan"    
    ]

    for (let i = 0; i <= 3; i++) {


        document.querySelector(Team[i]).addEventListener("click", () => {

            if (document.querySelector(Team[i]).classList.contains("shut")) {
                Descriptions[i].classList.remove("show_description")
                document.querySelector(Team[i]).classList.remove("shut")
                document.querySelector(Team[i]).classList.remove("hightlight")
            } else {
                document.querySelector(Team[i]).classList.add("hightlight")
                document.querySelector(Team[i]).classList.add("shut")
                Descriptions[i].classList.add("show_description")
            }

        })
            Close[i].addEventListener("click", () => {
            Descriptions[i].classList.remove("show_description")
            document.querySelector(Team[i]).classList.remove("hightlight")

        })
    }
}

if (document.querySelector("body").classList.contains("ui-kit")) {
    var ddiv = function ddiv(x3) {
      if (x3.matches) {
        Texte.innerHTML = "Police (Version Tablette)";
        Texte1.innerHTML = "81px - League Gothic";
        Texte2.innerHTML = "38px - League Gothic";
        Texte3.innerHTML = "26 pixels - League Gothic";
        Texte4.innerHTML = "18 pixels - Sofia Sans";
        Texte5.innerHTML = "Rapport hierarchique : 1.458";
      }
    };
  
  
  
    var _cdiv = function _cdiv(x) {
      if (x.matches) {
        Texte.innerHTML = "Police (Version Tablette)";
        Texte1.innerHTML = "81px - League Gothic";
        Texte2.innerHTML = "38px - League Gothic";
        Texte3.innerHTML = "26 pixels - League Gothic";
        Texte4.innerHTML = "18 pixels - Sofia Sans";
        Texte5.innerHTML = "Rapport hierarchique : 1.458";
      }
    };
  
    var _ediv = function _ediv(x1) {
      if (x1.matches) {
        Texte.innerHTML = "Police (Version Téléphone)";
        Texte1.innerHTML = "64 pixels - League Gothic";
        Texte2.innerHTML = "32 pixels - League Gothic";
        Texte3.innerHTML = "23 pixels - League Gothic";
        Texte4.innerHTML = "16 pixels - Sofia Sans";
        Texte5.innerHTML = "Rapport hierarchique : 1.414";
      }
    };
  
    var bdiv = function bdiv(x2) {
      if (x2.matches) {
        Texte.innerHTML = "Police (Version PC)";
        Texte1.innerHTML = "152 pixels - League Gothic";
        Texte2.innerHTML = "68 pixels - League Gothic";
        Texte3.innerHTML = "30 pixels - League Gothic";
        Texte4.innerHTML = "20 pixels - Sofia Sans";
        Texte5.innerHTML = "Rapport hierarchique : 1.5";
      }
    };
  
  
    var Texte = document.querySelector(".texte_police");
    var Texte1 = document.querySelector(".description_grand_titre");
    var Texte2 = document.querySelector(".description_titre");
    var Texte3 = document.querySelector(".description_sous_titre");
    var Texte4 = document.querySelector(".description_texte");
    var Texte5 = document.querySelector(".hierarchy")
    var x3 = window.matchMedia("(max-width: 1082px)");
    ddiv(x3);
    x3.addListener(ddiv);
  
    var _x = window.matchMedia("(min-width: 700px)");
  
    _cdiv(_x);
  
    _x.addListener(_cdiv);
  
    var _x2 = window.matchMedia("(max-width: 699px)");
  
    _ediv(_x2);
  
    _x2.addListener(_ediv);
  
    var x2 = window.matchMedia("(min-width: 1083px)");
    bdiv(x2);
    x2.addListener(bdiv);

  }